<script setup>
import { ref, watch } from 'vue';
import { YandexMap, YandexMarker } from 'vue-yandex-maps';

const props = defineProps({
    location: {
        type: Object,
        default: () => ({})
    }
});

const coordinates = ref([
    Number(props.location.pick_up_location_name.latitude),
    Number(props.location.pick_up_location_name.longitude)
]);
let showMap = ref(false)
const mapKey = ref(0);
const controls = [];
const detailedControls = { zoomControl: { position: { right: 10, top: 50 } } };

watch(
    () => props.location,
    (newLocation) => {
        coordinates.value = [
            Number(newLocation.pick_up_location_name.latitude),
            Number(newLocation.pick_up_location_name.longitude)
        ];
        mapKey.value += 1;
    },
    { deep: true, immediate: true }
);
onMounted(() => {
    showMap.value = true
})
</script>

<template>
    <YandexMap 
        v-if="location && location.pick_up_location_name.latitude && location.pick_up_location_name.longitude && showMap"
        :coordinates="coordinates"     
        :detailed-controls="detailedControls"
        :controls="controls" 
        width="100%" 
        height="400px"
        type-map="scheme"
    >
        <YandexMarker :coordinates="coordinates" />
    </YandexMap>
</template>

<style>
.yandex-container {
    height: 400px;
}
</style>